import Head from 'next/head'
import { FC } from 'react'
import { useRouter } from 'next/router'

interface SEOProps {
  title?: string
  description?: string
  keywords?: string
  image?: string
  article?: boolean
}

export const SEO: FC<SEOProps> = ({
  title = 'Delayed Send for Microsoft Teams',
  description = 'Schedule messages to be sent later in Microsoft Teams with advanced scheduling features',
  keywords = 'Microsoft Teams, delayed messages, scheduling, team productivity, Microsoft Teams app',
  image = '/logo.png',
  article = false,
}) => {
  const router = useRouter()
  // Use environment variable for site URL if available, otherwise fallback to production URL
  const siteUrl = typeof window !== 'undefined' 
    ? window.location.origin 
    : (process.env.SITE_URL || 'https://sendlater.app')
  const canonicalUrl = `${siteUrl}${router.asPath}`
  
  return (
    <Head>
      <title key="title">{title}</title>
      <meta key="description" name="description" content={description} />
      <meta key="keywords" name="keywords" content={keywords} />
      
      {/* Open Graph / Facebook */}
      <meta key="og:type" property="og:type" content={article ? 'article' : 'website'} />
      <meta key="og:url" property="og:url" content={canonicalUrl} />
      <meta key="og:title" property="og:title" content={title} />
      <meta key="og:description" property="og:description" content={description} />
      <meta key="og:image" property="og:image" content={`${siteUrl}${image.startsWith('/') ? image : `/${image}`}`} />
      
      {/* Twitter */}
      <meta key="twitter:card" property="twitter:card" content="summary_large_image" />
      <meta key="twitter:url" property="twitter:url" content={canonicalUrl} />
      <meta key="twitter:title" property="twitter:title" content={title} />
      <meta key="twitter:description" property="twitter:description" content={description} />
      <meta key="twitter:image" property="twitter:image" content={`${siteUrl}${image.startsWith('/') ? image : `/${image}`}`} />
      
      {/* Canonical link */}
      <link key="canonical" rel="canonical" href={canonicalUrl} />
    </Head>
  )
}